import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SettingsState } from "../_reducers/settings.reducers";

export const selectSettingsState = createFeatureSelector<SettingsState>("settings");

export const selectSettings = createSelector(selectSettingsState, (state: SettingsState) => state.settings);

export const selectSettingsError = createSelector(selectSettingsState, (state: SettingsState) => state.error);
